import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustedBy } from "@/components/landing/TrustedBy";
import { Roles } from "@/components/landing/Roles";
import { Workflow } from "@/components/landing/Workflow";
import { Modules } from "@/components/landing/Modules";
import { RoiCalculator } from "@/components/landing/RoiCalculator";
import { DemoForm } from "@/components/landing/DemoForm";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#090d16] font-sans">
      <Navbar />
      <main>
        <Hero />
        <TrustedBy />
        <Roles />
        <Workflow />
        <Modules />
        <RoiCalculator />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
}
